import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useRootfileStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function RootFilesGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid
    filters={null}
  />
}

export default function RootFilesGridLayout() {
  return <GridProvider store={useRootfileStore()}>
    <RootFilesGrid />
  </GridProvider>
}
